<template>
  <v-container fluid>
    <v-row no-gutters align="center">
      <v-col cols="auto">
        <ArticleImage :key="imageKey" :relativePath="editItem.ArticleImage" :size="130" :editable="!readonly"
          @File="file => { editItem.newArticleImage = file; handleFocus(true); }">
        </ArticleImage>
      </v-col>
      <v-col cols="0" class="pa-4">
        <!-- <UsedAlert :usedConfig="usedConfig"></UsedAlert> -->
        <QTextField v-model="editItem.ArticleNumber" :label="$t('servicesystem.common_objects.article.articleNumber')"
          :rules="[requiredRule]" :disabled="readonly || !isNew" :externaledit="isNew && editMode" maxlength="50"
          @FocusState="handleFocus">
          <!--  :errormessages="usedConfig ? [usedConfig.message] : undefined" @DebouncedInput="checkCustomerGroupId" -->
        </QTextField>
        <QTextField v-model="editItem.ArticleDescription" :externaledit="editMode" maxlength="100"
          :label="$t('servicesystem.common_objects.article.articleDescription')" :disabled="readonly"
          :rules="[requiredRule]" class="mt-4" @FocusState="handleFocus">
        </QTextField>
        <QTextArea v-if="editMode || editItem.ArticleDescriptionLong" v-model="editItem.ArticleDescriptionLong"
          maxlength="100" :externaledit="editMode"
          :label="$t('servicesystem.common_objects.article.articleDescriptionLong')" :disabled="readonly" class="mt-4"
          @FocusState="handleFocus">
        </QTextArea>
        <QTextField :externaledit="editMode" @FocusState="handleFocus"
          v-if="editItem.IsStoreArticle && !editItem.TechnicianSparePart" v-model="editItem.SalesText"
          :label="salesTextLabel" :disabled="readonly">
        </QTextField>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row no-gutters align="stretch">
      <v-col class="pa-4" cols="12" sm="6">
        <h3>{{ $t('servicesystem.common_objects.article.settings') }}</h3>
        <supplier-select v-model="editItem.SupplierId" allowCreate clearable :externaledit="editMode" hideIcon
          class="mt-3" :disabled="readonly" @FocusState="handleFocus">
        </supplier-select>
        <QSwitchInput v-model="editItem.IsStoreArticle" :externaledit="editMode"
          :label="$t('servicesystem.common_objects.article.isstorearticle')" :disabled="readonly" class="mt-3"
          @FocusState="handleFocus">
        </QSwitchInput>
        <QCheckboxInput v-model="editItem.TechnicianSparePart" :externaledit="editMode"
          :label="$t('servicesystem.common_objects.article.techniciansparepart')" :disabled="readonly"
          :trueValue="false" :falseValue="true" class="mt-3" @FocusState="handleFocus">
        </QCheckboxInput>
        <QCheckboxInput v-if="!isNew" v-model="editItem.IsActive" :externaledit="editMode" :disabled="readonly"
          :label="$t('servicesystem.common_objects.commonterms.active')" class="mt-3" @FocusState="handleFocus">
        </QCheckboxInput>
      </v-col>
      <v-divider :vertical="!isPhoneBool" style="z-index: 1;"></v-divider>
      <v-col class="pa-4" cols="12" sm="6">
        <h3>{{ $t('servicesystem.common_objects.article.pricing') }}</h3>
        <QTextField v-model="editItem.ArticlePrice" :externaledit="editMode" :disabled="readonly"
          :label="$t('servicesystem.common_objects.article.price')" class="mt-3" @FocusState="handleFocus">
        </QTextField>
        <QTextField v-model="editItem.ArticlePriceIn" :externaledit="editMode" :disabled="readonly"
          :label="$t('servicesystem.common_objects.article.pricein')" class="mt-3" @FocusState="handleFocus">
        </QTextField>
        <QTextField v-model="editItem.VatRate" :externaledit="editMode" :disabled="readonly"
          :label="$t('servicesystem.common_objects.article.vatrate')" class="mt-3" @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import ArticleImage from "@/views/pim/articles/ArticleImage.vue";
//import UsedAlert from "@/components/UsedAlert.vue";
import SupplierSelect from '../../../components/Inputs/EntityDropdowns/SupplierSelect2.vue';

export default {
  name: "ArticleEditContent",
  props: {
    readonly: Boolean,
    originalItem: Object,
    editItem: Object,
    editMode: Boolean,
    handleFocus: {
      type: Function,
      default: () => { },
    },
  },
  components: {
    ArticleImage,
    SupplierSelect,
    //UsedAlert,
  },
  mixins: [clientAPI],

  data() {
    return {
      imageKey: 1,
      //used: null,
    };
  },

  mounted() { },

  methods: {
    /*
    async checkCustomerGroupId(id) {
      if (!id) {
        this.used = null;
      } else {
        await this.getCustomerGroupById(id)
          .then((response) => {
            //console.log(response);
            this.used = response;
          })
          .catch((e) => {
            if (e.status == 204) {
              this.used = null;
            }
            else {
              console.error(e)
            }
          });
      }
    },
    */
  },

  computed: {
    salesTextLabel() {
      var override = this.FieldMapping.Article?.SalesText?.DisplayName;
      return override || this.$t('servicesystem.common_objects.article.salestext');
    },

    isNew() {
      return this.originalItem?.Id == null;
    },
    /*
    usedConfig() {
      if (this.used) {
        return {
          message: this.$t('servicesystem.common_objects.customer_group.id_in_use', { kkey: this.$t('servicesystem.common_objects.customer_group.number'), ckey: this.used.Name }),
          openText: this.$t('servicesystem.common_objects.customer_group.view_customer_group', { ckey: this.used.Name }),
          route: { name: 'ViewCustomerGroup', params: { customerGroupId: this.used.Id } },
        };
      }
      else {
        return null;
      }
    }
    */
  },

  watch: {
    editMode: function (newVal) {
      if (!newVal) {
        this.imageKey++;
      }
    },
  },
};
</script>


<style lang='scss'></style>